import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiDataService } from './api.data.service';
import {
    ClientTBQuestionnaireModel,
    TBCalculateResultModel,
    TBQuestionnaireModel,
    TBQuestionnaireSubmit,
} from 'core/models/tb-questionnaire.model';

@Injectable({
    providedIn: 'root',
})
export class ApiTBQuestionnairesService extends ApiDataService<TBQuestionnaireModel> {
    constructor(http: HttpClient) {
        super(http, '/');
    }

    public getTBQuestionnaire(id: number): Observable<TBQuestionnaireModel> {
        return this.get<TBQuestionnaireModel>(`TBQuestionnaires/${id}`);
    }

    public calculateTBResult(params: TBQuestionnaireSubmit): Observable<TBCalculateResultModel> {
        return this.post<TBCalculateResultModel>(
            'ClientTBQuestionnaires/CalculateResult',
            JSON.stringify(params),
        );
    }

    public getClientTBQuestionnaire(id: number): Observable<ClientTBQuestionnaireModel> {
        return this.get<ClientTBQuestionnaireModel>(`ClientTBQuestionnaires/${id}`);
    }

    public exportClientTBQuestionnaire(id: number): Observable<HttpResponse<Blob>> {
        return this.exportFile<HttpResponse<Blob>>(`ClientTBQuestionnaires/${id}/Export`);
    }
}
